@let imageResponse = getSignal('image')();
@let titleResponse = getSignal('title')();
@let descriptionResponse = getSignal('description')();
@if (imageResponse.success && titleResponse.success && descriptionResponse.success) {
<app-editable-image 
    [elemId]="imageResponse.payload"
    [imageReference]="imageReference"
    [fileTypes]="supportedFileTypes"
    [maxWidth]="600"
    [maxHeight]="600"
    [isClickable]="true"
    [customClass]="'base-card-custom-class-image'">
</app-editable-image>
<div class="overlay costum-mat-secondary-container">
    <app-editable-text 
        [customClass]="'custom-title-medium'" 
        [elemId]="titleResponse.payload">
    </app-editable-text>
    @if(hasDescription()) {
        <app-editable-text 
        [customClass]="'custom-label-medium'" 
        [elemId]="descriptionResponse.payload">
    </app-editable-text>
    }   
</div>
}